// extracted by mini-css-extract-plugin
export default {"container":"DataTable_container__DAfhy","icon":"DataTable_icon__Oux15"};